import InitialContent from './InitialContent';

export default InitialContent;
